import React from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';

const QuizResultModal = ({
  completionSummary,
  formatDuration,
  onClose,
  onReview,
  show,
  text,
}) => {
  if (!completionSummary) {
    return null;
  }

  return (
    <Modal
      className="modal-theme-bg quiz-completion-modal"
      show={show}
      onHide={() => {}}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title as="h5">
          {completionSummary.isOpenOnly ? text.quizCompleted : text.quizCompletedWithIcon}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {completionSummary.isOpenOnly ? (
          <>
            <div className="quiz-completion-open-count">{text.openQuestionsSummary(completionSummary.openTotal)}</div>
            <div className="quiz-completion-time">{text.timeSummary(formatDuration(completionSummary.durationSeconds))}</div>
            <Alert variant="warning" className="mt-3 mb-0">
              {text.openOnlyQuizNote}
            </Alert>
          </>
        ) : (
          <>
            <div className="quiz-completion-score text-center mb-3">
              <div className="quiz-completion-score-label">{text.calculatedScore}</div>
              <div className="quiz-completion-score-main">
                {completionSummary.correctClosed}/{completionSummary.closedTotal}
              </div>
              <div className="quiz-completion-score-percent">{completionSummary.scorePercent}%</div>
            </div>
            <div className="quiz-completion-time mb-3">{text.timeSummary(formatDuration(completionSummary.durationSeconds))}</div>
            <div className="quiz-completion-breakdown">
              <div>{text.correctAnswersSummary(completionSummary.correctClosed)}</div>
              <div>{text.wrongAnswersSummary(completionSummary.wrongClosed)}</div>
              {completionSummary.openTotal > 0 && (
                <div>{text.openQuestionsSummary(completionSummary.openTotal)}</div>
              )}
            </div>
            {completionSummary.openTotal > 0 && (
              <Alert variant="info" className="mt-3 mb-0">
                {text.mixedQuizOpenNote}
              </Alert>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="quiz-completion-actions">
        <Button type="button" variant="primary" onClick={onReview}>{text.reviewQuiz}</Button>
        <Button type="button" variant="soft-danger" onClick={onClose}>{text.close}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QuizResultModal;
